import { render, staticRenderFns } from "./onboarding-home.vue?vue&type=template&id=59eac255&scoped=true"
import script from "./onboarding-home.vue?vue&type=script&lang=js"
export * from "./onboarding-home.vue?vue&type=script&lang=js"
import style0 from "./onboarding-home.vue?vue&type=style&index=0&id=59eac255&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eac255",
  null
  
)

export default component.exports